export default "__VITE_ASSET__3f0db316__"